import React from 'react';

import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  LoginOutlined,
  ThunderboltOutlined,
  DatabaseOutlined,
} from '@ant-design/icons';

import { Tag, Row, Col, Divider, Tooltip } from 'antd';
import moment from 'moment';
import FinderSuppressReason from './components/FinderSuppressReason';
// ant-tooltip-content
function RenderInnerSignature(props) {
  let { record, showSuppress, openDrawer } = props;
  let { risks, creationOfRisk } = record;

  if (!risks || risks.length === 0) {
    return <div>No risk found</div>;
  }

  // risks = risks.filter(v => v.status.toLowerCase() === 'fail');

  let finalSortedData;
  if (!showSuppress) {
    finalSortedData = getUnSuppressedRisks(risks);
  }
  finalSortedData = sortRisks(risks);

  let scannedOn = moment(creationOfRisk).fromNow();
  let scannedOnTime = moment(creationOfRisk).format('MMM Do, YYYY hh:mm a');

  if (scannedOn === 'Invalid date') {
    scannedOn = moment(creationOfRisk.toDate()).fromNow();
    scannedOnTime = moment(creationOfRisk.toDate()).format('MMM Do, YYYY hh:mm a');
  }

  return (
    <div style={{ marginBottom: -41, marginLeft: 40 }}>
      {finalSortedData.map((singleRisk, i) => {
        let {
          signatureName,
          description,
          risk,
          suppress,
          status,
          firstSeen,
          lastSeen,
        } = singleRisk;
        let suppressProps = {
          type: 'risk',
          record: singleRisk,
          i: i,
        };
        return (
          <div
            key={i}
            style={{
              backgroundColor: suppress ? 'FAFAFA' : '',
              opacity: suppress ? '0.5' : '',
            }}
          >
            <Row>
              <Col style={{ fontSize: '13px', color: '#1890FF', fontWeight: 500 }} span={13}>
                <div>
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      let drawerParams = [
                        {
                          type: 'signatureName',
                          value: [signatureName],
                        },
                      ];
                      openDrawer(drawerParams, 'signatureDrawer');
                    }}
                  >
                    {description}
                    <LoginOutlined
                      onClick={() => {
                        let extraFilteration = {
                          type: 'signatureName',
                          value: [signatureName],
                        };
                        // return;
                        // getResourceData(extraFilteration, 'signatureDrawer');
                      }}
                      style={{ color: '#1890FF', marginLeft: '5px' }}
                    />
                  </div>
                  <div
                    style={{
                      marginTop: '6px',
                      marginBottom: '-8px',
                      fontSize: '12px',
                      color: ' #8C8C8C',
                      fontWeight: 400,
                    }}
                  >
                    <Tooltip title={`Signature ID: ${signatureName}`}>
                      {singleRisk.dataSource ? (
                        <span>
                          <DatabaseOutlined style={{ fontSize: '13px', marginRight: '3px' }} />
                          {singleRisk.dataSource}
                        </span>
                      ) : (
                        ''
                      )}{' '}
                      <ThunderboltOutlined style={{ fontSize: '13px' }} />
                      {` `}
                      {signatureName}
                    </Tooltip>
                    <Tooltip title={`First Seen: ${getScannedOnTime(firstSeen).scannedOnTime}`}>
                      <ClockCircleOutlined style={{ marginLeft: '12px', fontSize: '13px' }} />
                      {` `}
                      {getScannedOnTime(firstSeen).scannedOn}
                    </Tooltip>
                  </div>
                </div>
              </Col>

              <Col span={3} offset={5} style={{ marginLeft: 213 }}>
                {risk.toLowerCase() === 'high' ? (
                  <Tag color="red">
                    {risk.charAt(0).toUpperCase() + risk.slice(1).toLowerCase()}
                  </Tag>
                ) : risk.toLowerCase() === 'low' ? (
                  <Tag color="blue">
                    {risk.charAt(0).toUpperCase() + risk.slice(1).toLowerCase()}
                  </Tag>
                ) : (
                  <Tag color="orange">
                    {risk.charAt(0).toUpperCase() + risk.slice(1).toLowerCase()}
                  </Tag>
                )}
              </Col>

              <Col span={2} style={{ marginLeft: -20 }}>
                <Tooltip
                  overlayStyle={{ maxWidth: 700 }}
                  placement="left"
                  title={<p>Last Scanned: {getScannedOnTime(lastSeen).scannedOnTime}</p>}
                >
                  {status.toLowerCase() === 'pass' ? (
                    <CheckCircleOutlined style={{ color: '#3ADFA3', fontSize: 25 }} />
                  ) : (
                    <CloseCircleOutlined style={{ color: '#F4657C', fontSize: 25 }} />
                  )}
                </Tooltip>
              </Col>
              <Col span={1} style={{ marginLeft: -4 }}>
                <FinderSuppressReason {...suppressProps} />
              </Col>
            </Row>
            <Divider type="horizontal" />
          </div>
        );
      })}
      <div
        style={{
          marginTop: -14,
          marginBottom: 37,
          textAlign: 'center',
        }}
      >
        <p
          style={{
            color: '#0090ff',
            cursor: 'pointer',
            marginTop: 8,
          }}
          onClick={() => {
            let drawerParams = [
              {
                type: 'resourceId',
                value: [record.id],
              },
              {
                type: 'cloudAccounts',
                value: [record.cloudAccountId],
              },
            ];
            // return;
            openDrawer(drawerParams, 'singleResource', true);
          }}
        >
          View Resource Profile
          <LoginOutlined style={{ color: '#1890FF', marginLeft: '5px' }} />
        </p>
      </div>
    </div>
  );
}

function getUnSuppressedRisks(data) {
  return data.filter(v => v.suppress === false);
}
function getScannedOnTime(creationOfRisk) {
  if (creationOfRisk) {
    let scannedOn = creationOfRisk.toDate
      ? moment(creationOfRisk.toDate()).fromNow()
      : moment(new Date(creationOfRisk?._seconds * 1000)).fromNow();
    let scannedOnTime = creationOfRisk.toDate
      ? moment(creationOfRisk.toDate()).fromNow()
      : moment(new Date(creationOfRisk?._seconds * 1000)).format('MMM Do, YYYY hh:mm a');

    if (scannedOn === 'Invalid date') {
      scannedOn = moment(new Date(creationOfRisk)).fromNow();
      scannedOnTime = moment(new Date(creationOfRisk)).format('MMM Do, YYYY hh:mm a');
    }
    return {
      scannedOn,
      scannedOnTime,
    };
  } else {
    let obj = {
      scannedOn: 'N/A',
      scannedOnTime: 'N/A',
    };
    return obj;
  }
}
function sortRisks(data) {
  let finalResp = data.reduce((accumulator, eachVal) => {
    if (eachVal.risk.toLowerCase() === 'high') {
      let oldAcc = accumulator.high || [];
      return { ...accumulator, high: [eachVal, ...oldAcc] };
    }
    if (eachVal.risk.toLowerCase() === 'medium') {
      let oldAcc = accumulator.medium || [];
      return { ...accumulator, medium: [eachVal, ...oldAcc] };
    }
    if (eachVal.risk.toLowerCase() === 'low') {
      let oldAcc = accumulator.low || [];
      return { ...accumulator, low: [eachVal, ...oldAcc] };
    }
    return accumulator;
  }, {});
  let failHigh = finalResp.high
    ? finalResp.high.filter(e => e.status.toLowerCase() === 'fail')
    : [];
  let passHigh = finalResp.high
    ? finalResp.high.filter(e => e.status.toLowerCase() === 'pass')
    : [];
  let failMedium = finalResp.medium
    ? finalResp.medium.filter(e => e.status.toLowerCase() === 'fail')
    : [];
  let passMedium = finalResp.medium
    ? finalResp.medium.filter(e => e.status.toLowerCase() === 'pass')
    : [];
  let failLow = finalResp.low ? finalResp.low.filter(e => e.status.toLowerCase() === 'fail') : [];
  let passLow = finalResp.low ? finalResp.low.filter(e => e.status.toLowerCase() === 'pass') : [];

  let finalSortedData = [
    ...failHigh,
    ...failMedium,
    ...failLow,
    ...passHigh,
    ...passMedium,
    ...passLow,
  ];
  return finalSortedData;
}

export default RenderInnerSignature;
